var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseLandingWithoutTabs',{attrs:{"faq-id":14},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',[_vm._v(_vm._s(_vm.$t('renew_header_home')))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }